import React, { useState, useEffect } from 'react';
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_TextInput from "../components/BSL_TextInput";
import * as BSL_Common from "../components/BSL_CommonControls";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import BSL_Select from "../components/BSL_Select";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import Autocomplete from "react-autocomplete";
import ManageProductListAncillary from './ManageProductListAncillary';


export function ReplaceAll(target, search, replacement) {
    return target.replace(new RegExp(search, "g"), replacement);
}

export default function ManageProductListFilter(props) {
    const { value, offering_editcell, saveValue, onClose, pricefileDescSummary } = props;

    let filter_raw = value ? value : [];

    const [displayData, setDisplayData] = React.useState(filter_raw);
    const [filterData, setFilterData] = React.useState(undefined);
    const [newCode, setNewCode] = React.useState("");
    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const [autocompleteOptions, setAutocomplateOptions] = React.useState(null);
    const [newFilterType, setNewFilterType] = React.useState("Code");
    const [displayDataValidJSON, setDisplayDataValidJSON] = React.useState(true);

    const materialCategories = ["BEAMS", "BRACKETS", "FLASHING", "STEEL ROOFING"];

    const checkValidJSON = (str) => {
        try {
            JSON.parse(str);
        } catch (ex) {
            try {
                JSON.parse("[" + str + "]");
            } catch (e) {
                setDisplayDataValidJSON(false);
                return false;
            }
        }
        setDisplayDataValidJSON(true);
        return true;
    };

    const handleTextChange = (filter_raw) => {
        let filter_items = [];
        if (filter_raw.startsWith && filter_raw.startsWith("{")) {
            let filter_raw_json = JSON.parse(filter_raw);
            filter_items = filter_raw_json["AncillaryParts"];
        } else if (typeof filter_raw === "object") {
            filter_items = filter_raw;
        } else {
            let split = filter_raw.split(" ");
            for (let i = 0; i < split.length; i++) {
                var this_item = split[i];
                if (this_item !== "") {
                    if (this_item.includes("(") && !this_item.includes(")") && i < split.length) {
                        while (i <= split.length) {
                            i++;
                            let next_bit = split[i];
                            this_item += " " + next_bit;
                            if (next_bit.includes(")")) break;
                        }
                    }
                    var this_item_object = {};
                    this_item_object.Code = this_item;

                    if (this_item.includes("x")) {
                        let split = this_item.split("x");
                        let is_numbers = /^\d+$/.test(split[0]);

                        if (is_numbers) {
                            split.forEach((str, i) => {
                                if (i === 0) this_item_object.Qty = str;
                                else if (i === 1) this_item_object.Code = str;
                                else this_item_object.Code += "x" + str;
                            });

                            if (this_item_object.Code.includes("(")) {
                                this_item_object.Use = this_item_object.Code.split("(")[1]
                                    .replace("(", "")
                                    .replace(")", "");
                                this_item_object.Code = this_item_object.Code.split("(")[0];
                            }
                        }
                    }

                    filter_items.push(this_item_object);
                }
            }
        }
        setFilterData(filter_items);
    };

    const updateFilterData = (index, parameter, value) => {
        let new_filterData = [...filterData];

        if (index === -1) {
            if (value !== "") {
                new_filterData.push({
                    [parameter]: value,
                    Operation: "delete",
                    Details: [],
                });
                setNewCode("");
            }
            setFilterData(new_filterData);
            return;
        }

        let item = new_filterData[index];
        if (!item) return;

        switch (parameter) {
            case "operation":
                item.Operation = value || "delete";
                break;
            case "ancillary":
                if (item) {
                    item.AncillaryParts = "{\"AncillaryParts\":[" + value + "]}";
                }
                break;
            case "modify":
                if (item) {
                    item.Details = value || [];
                }
                break;
        }

        if (item.Operation === 'delete') {
            delete item.AncillaryParts;
        }

        setFilterData(new_filterData);
    }

    const handleDeleteRow = (index) => {
        let new_filterData = filterData
            .slice(0, index)
            .concat(filterData.slice(index + 1, filterData.length));
        setFilterData(new_filterData);
    };

    useEffect(() => {
        setDisplayData(ReplaceAll(JSON.stringify(filterData).substring(1).slice(0, -1), "},", "},\n"));
    }, [filterData]);

    if (filterData === undefined) {
        let filter_items = [];

        if (filter_raw.startsWith && filter_raw.startsWith("{")) {
            let filter_raw_json = JSON.parse(filter_raw);
            filter_items = filter_raw_json["AncillaryParts"];
        } else if (typeof filter_raw === "object") {
            filter_items = filter_raw;
        } else {
            let split = filter_raw.split(" ");

            for (let i = 0; i < split.length; i++) {
                var this_item = split[i];
                if (this_item !== "") {
                    if (this_item.includes("(") && !this_item.includes(")") && i < split.length) {
                        while (i <= split.length) {
                            i++;
                            let next_bit = split[i];
                            this_item += " " + next_bit;
                            if (next_bit.includes(")")) break;
                        }
                    }

                    var this_item_object = {};
                    this_item_object.Code = this_item;

                    if (this_item.includes("x")) {
                        let split = this_item.split("x");
                        let is_numbers = /^\d+$/.test(split[0]);

                        if (is_numbers) {
                            split.forEach((str, i) => {
                                if (i === 0) this_item_object.Qty = str;
                                else if (i === 1) this_item_object.Code = str;
                                else this_item_object.Code += "x" + str;
                            });

                            if (this_item_object.Code.includes("(")) {
                                this_item_object.Use = this_item_object.Code.split("(")[1]
                                    .replace("(", "")
                                    .replace(")", "");
                                this_item_object.Code = this_item_object.Code.split("(")[0];
                            }
                        }
                    }
                    filter_items.push(this_item_object);
                }
            }
        }
        setFilterData(filter_items);
    }

    let filter_rows = [];

    if (!autocompleteOptions) {
        let options = [];

        for (let option in pricefileDescSummary) {
            options.push(option + " - " + pricefileDescSummary[option]);
        }
        setAutocomplateOptions(options);
    }

    if (filterData) {
        let row_i = 0;

        for (let filterRow of filterData) {
            let row_num = row_i;
            let filterType = Object.keys(filterRow)[0] || "";
            let filterValue = filterRow?.[Object.keys(filterRow)[0]] || "";

            const parent = {
                rowNum: row_num,
                item: filterRow?.Code || filterRow?.Category || "",
                operation: filterRow?.Operation,
                filterType: filterType
            };

            row_i++;
            filter_rows.push(
                <BSL_Common.SectionRow
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        backgroundColor: row_num % 2 === 0 ? "#4bafad" : "#a0dd2f",
                    }}
                >
                    <BSL_Common.SectionColumn
                        style={{
                            width: "32px",
                            height: "100%",
                            paddingTop: "8px",
                            flex: "none",
                        }}
                    >
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                setConfirmDelete(row_num);
                            }}
                        >
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </BSL_Common.SectionColumn>
                    <div
                        style={{
                            flex: "0 0 10%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <label
                            style={{
                                font: "200 13px canada-type-gibson, sans-serif",
                                paddingTop: "14px",
                                paddingBottom: "10px",
                            }}
                        >
                            {filterType}
                        </label>
                        <span
                            style={{
                                font: "600 18px canada-type-gibson, sans-serif",
                                paddingBottom: "8px",
                            }}
                        >
                            {filterValue}
                        </span>
                    </div>
                    <BSL_Select
                        label={"Operation"}
                        tight={true}
                        value={filterRow?.Operation || ""}
                        onChange={(event) => { updateFilterData(row_num, "operation", event.target.value) }}
                        items={["modify", "delete"]}
                        style={{ flex: "0 0 8%" }}
                        selectStyle={{ background: "white", width: "120px" }}
                    >
                    </BSL_Select>
                    <ManageProductListAncillary
                        value={filterRow?.Details || []}
                        mode={"OFFERING"}
                        onClose={() => saveValue(null)}
                        saveValue={updateFilterData}
                        pricefileDescSummary={pricefileDescSummary}
                        embed={true}
                        subhead={"Replace with ..."}
                        parent={parent}
                    />
                </BSL_Common.SectionRow>
            );
            if (filterRow?.Operation === "modify") {
                const ancillaryParent = { rowNum: row_num };
                filter_rows.push(
                    <BSL_Common.SectionRow
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                            backgroundColor: row_num % 2 === 0 ? "" : "#f4f1eb",
                        }}
                    >
                        <ManageProductListAncillary
                            row={{
                                AncillaryParts: filterRow?.AncillaryParts || [],
                            }}
                            onClose={() => saveValue(null)}
                            saveValue={updateFilterData}
                            pricefileDescSummary={pricefileDescSummary}
                            embed={true}
                            subhead={"Replace ancillary items with ..."}
                            parent={ancillaryParent}
                        />
                    </BSL_Common.SectionRow>
                );
            }
        }
    }

    let title = "Edit Items for " + offering_editcell?.title;

    return (
        <BSL_Dialog
            title={title}
            open={true}
            button1Text="Update"
            button1Disabled={!displayDataValidJSON}
            button1Click={() => {
                saveValue(offering_editcell?.POA, offering_editcell?.key_path, filterData);
            }}
            button2Text="Cancel"
            button2Click={onClose}
            style={{ maxWidth: "initial" }}
            fullWidth={true}
            maxWidth={"xl"}
        >
            <textarea
                id="w3review"
                name="w3review"
                style={{
                    backgroundColor: "beige",
                    fontFamily: "monospace",
                    padding: "10px",
                    borderRadius: "9px",
                    color: "#444444",
                    maxHeight: "400px",
                    overflowY: "auto",
                    fontSize: "12px",
                    width: "98%",
                }}
                rows="6"
                onChange={(e) => {
                    setDisplayData(e.target.value);
                    if (checkValidJSON(e.target.value)) {
                        handleTextChange(JSON.parse("[" + e.target.value + "]"));
                    }
                }}
                onBlur={(e) => {
                    if (checkValidJSON(e.target.value)) {
                        handleTextChange(JSON.parse("[" + e.target.value + "]"));
                        setDisplayData(
                            ReplaceAll(
                                JSON.stringify("[" + e.target.value + "]")
                                    .substring(1)
                                    .slice(0, -1),
                                "},",
                                "},\n"
                            )
                        );
                    }
                }}
                value={displayData}
            />
            <div
                style={{
                    color: displayDataValidJSON ? "green" : "red",
                    fontSize: "12px",
                    padding: "10px",
                    textAlign: "center",
                }}
            >
                {displayDataValidJSON ? "VALID JSON" : "NOT VALID JSON"}
            </div>

            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "600px",
                }}
            >
                {filter_rows}
                <BSL_Common.SectionRow
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        flexWrap: "wrap",
                        flexDirection: "column",
                        marginTop: "2em"
                    }}
                >
                    <SegmentedButtonGroup
                        label="Add New Filter by Product"
                        tight={true}
                        value={newFilterType}
                        items={["Code", "Category"]}
                        onChange={(e, val) => {
                            setNewFilterType(val);
                            setNewCode("");
                            e.stopPropagation();
                        }}
                        style={{
                            marginTop: "-12px",
                            flex: 7,
                        }}
                    />
                    <div style={{ position: 'relative'}}>
                        <Autocomplete
                            items={newFilterType === "Code" ? autocompleteOptions : materialCategories}
                            shouldItemRender={(item, value) => {
                                if (!item.toLowerCase || !value.toLowerCase) return false;
                                return item.toLowerCase().indexOf(value.toLowerCase()) > -1;
                            }}
                            autoHighlight={false}
                            getItemValue={(item) => item}
                            renderItem={(item, highlighted) => (
                                <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                    {item}
                                </div>
                            )}
                            menuStyle={{
                                zIndex: '999999',
                                backgroundColor: 'whitesmoke',
                                boxShadow: '1px 1px 4px',
                                fontSize: '12px',
                                marginLeft: '9px',
                                lineHeight: 1.4,
                                width: "100%",
                                maxHeight: "200px",
                                overflowY: "auto",
                            }}
                            renderInput={(props) => {
                                return (
                                    <BSL_TextInput
                                        label={newFilterType}
                                        value={newCode}
                                        placeholder={"New Item"}
                                        InputProps={{
                                            style: { width: "400px" },
                                            ...props,
                                        }}
                                    />
                                );
                            }}
                            value={newCode}
                            onChange={(e) => setNewCode(e.target.value.split("-")[0].trim())}
                            onSelect={(value) => setNewCode(value.split("-")[0].trim())}
                        />
                        <IconButton
                            aria-label="add"
                            size="small"
                            onClick={() => {
                                updateFilterData(-1, newFilterType, newCode);
                            }}
                        >
                            <AddIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                </BSL_Common.SectionRow>
            </div>
            <BSL_Dialog
                title={"Confirm Delete"}
                open={confirmDelete !== null}
                button1Text="Delete"
                button1Click={() => {
                    handleDeleteRow(confirmDelete);
                    setConfirmDelete(null);
                }}
                button2Text="Cancel"
                button2Click={() => {
                    setConfirmDelete(null);
                }}
            >
                Are you sure you want to delete filter row {confirmDelete + 1}?
            </BSL_Dialog>
        </BSL_Dialog>
    );
}